import ActivityChipTableCell from 'Components/ActivityChipTableCell'
import LabelTableCell from 'Components/LabelTableCell'
import StyledTableRow from 'Components/StyledTableRow'
import type { Device } from 'Services/ServiceProviderManagement/Features/Device/types'
import { IS_WALTTI_SERVICE_ENVIRONMENT } from 'Util/constants'
import { datetimeFormatter, showValueOrHyphen } from 'Util/formatters'
import { Paper, styled, Table, TableBody, TableCell, TableContainer } from '@mui/material'
import { t } from 'ttag'

const StyledTableCell = styled(LabelTableCell)`
  width: 40%;
`

interface DeviceDetailsProps {
  device: Device
}

function DeviceDetails({ device }: Readonly<DeviceDetailsProps>) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ td: { border: 'none' } }} aria-label={t`Details table`}>
        <TableBody>
          <StyledTableRow>
            <StyledTableCell>{t`Device name`}</StyledTableCell>
            <TableCell>{showValueOrHyphen(device.name)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Status`}</StyledTableCell>
            <ActivityChipTableCell
              active={device.active}
              activity_end_date={device.activity_end_date}
            />
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Created`}</StyledTableCell>
            <TableCell>{datetimeFormatter(device.created_timestamp)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Activity end date`}</StyledTableCell>
            <TableCell>{datetimeFormatter(device.activity_end_date)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Source`}</StyledTableCell>
            <TableCell>{showValueOrHyphen(device.source)}</TableCell>
          </StyledTableRow>
          {IS_WALTTI_SERVICE_ENVIRONMENT && (
            <>
              <StyledTableRow>
                <StyledTableCell>{t`Directory alias`}</StyledTableCell>
                <TableCell>{showValueOrHyphen(device.directory_alias)}</TableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell>{t`Machine uuid`}</StyledTableCell>
                <TableCell>{showValueOrHyphen(device.machine_uuid)}</TableCell>
              </StyledTableRow>
            </>
          )}
          <StyledTableRow>
            <StyledTableCell>{t`Last modified`}</StyledTableCell>
            <TableCell>{datetimeFormatter(new Date(device.modified_timestamp))}</TableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default DeviceDetails
